import { useEffect } from "react";
import Lenis from "lenis";
import { I18nProvider } from "./lib/i18n";
import Nav from "./components/site/Nav";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import OurServices from "./components/site/OurServices";
import Industries from "./components/site/Industries";
import About from "./components/site/About";
import Services from "./components/site/Services";
import Why from "./components/site/Why";
import Speaking from "./components/site/Speaking";
import Pricing from "./components/site/Pricing";
import Portfolio from "./components/site/Portfolio";
import CtaBanner from "./components/site/CtaBanner";
import Contact from "./components/site/Contact";
import FollowMe from "./components/site/FollowMe";
import Footer from "./components/site/Footer";
import FloatingWhatsApp from "./components/site/FloatingWhatsApp";
import "./App.css";

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.5,
            smoothWheel: true,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        });
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
        return () => {
            lenis.destroy();
        };
    }, []);

    return (
        <I18nProvider>
            <div
                className="min-h-screen bg-[#050505] text-white"
                data-testid="app-root"
            >
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <OurServices />
                    <Industries />
                    <About />
                    <Services />
                    <Why />
                    <Speaking />
                    <Pricing />
                    <Portfolio />
                    <CtaBanner />
                    <Contact />
                    <FollowMe />
                </main>
                <Footer />
                <FloatingWhatsApp />
            </div>
        </I18nProvider>
    );
}

export default App;
